import sample_1 from './exclusiveFerro.jpg';

export const exclusiveFerroImpressions = {
    sample_1,
};
